import { firestore } from '@src/api/Firebase/Firebase';
import { collection } from 'firebase/firestore';
import { getUnitCost, getUnitCostSale, Input } from '@api/Inputs/Input';

export interface RecipeItem {
    inputId: string;
    quantity: number; // en la unidad BASE del insumo (input.unit.unit)
    optional?: boolean; // true = el cliente puede quitarlo ("sin aderezo")
}

export interface Recipe {
    id?: string;
    name: string;
    items: RecipeItem[];
    availableForModifiers: boolean; // puede usarse como opción en grupos de modificadores
    // Derivado persistido al guardar (RecipeServ.saveRecipe lo recalcula SIEMPRE — no capturar a mano)
    cost?: number; // Σ quantity × input.unitCost → costo de compra de la receta
    status: boolean;
}

export const buildInputsById = (inputs: Input[]): Map<string, Input> => {
    const inputsById = new Map<string, Input>();
    inputs.forEach((input) => {
        if (input?.id) {
            inputsById.set(input.id, input);
        }
    });
    return inputsById;
};

// Costeo de la receta a costo de compra (food-cost corporativo). Insumos no encontrados suman $0;
// usar getRecipeMissingInputIds para detectarlos y avisar en la UI.
export const getRecipeCost = (items: RecipeItem[], inputsById: Map<string, Input>): number => {
    return (items || []).reduce((total, item) => {
        const input = item.inputId ? inputsById.get(item.inputId) : undefined;
        if (!input) {
            return total;
        }
        const unitCost = input.unitCost ?? getUnitCost(input);
        return total + (Number(item.quantity) || 0) * unitCost;
    }, 0);
};

// Costeo a costo de traspaso CEDIS→sucursal (margen visto desde la sucursal)
export const getRecipeCostSale = (items: RecipeItem[], inputsById: Map<string, Input>): number => {
    return (items || []).reduce((total, item) => {
        const input = item.inputId ? inputsById.get(item.inputId) : undefined;
        if (!input) {
            return total;
        }
        const unitCostSale = input.unitCostSale ?? getUnitCostSale(input);
        return total + (Number(item.quantity) || 0) * unitCostSale;
    }, 0);
};

export const getRecipeMissingInputIds = (items: RecipeItem[], inputsById: Map<string, Input>): string[] => {
    return (items || [])
        .map((item) => item.inputId)
        .filter((inputId) => !!inputId && !inputsById.has(inputId));
};

export const RECIPES_COLLECTION = 'recipes';

export const recipesRef = collection(firestore, RECIPES_COLLECTION);
